import { createContext, useContext } from 'react';

export const LayoutContext = createContext({ collapsed: false });

export const useLayout = () => useContext(LayoutContext);

// Название страницы в шапке журнала — показывается только при свёрнутом левом меню
export const PageTitle = ({ children }) => {
    const { collapsed } = useLayout();
    return collapsed ? <span className="page-toolbar-title">{children}</span> : null;
};
